import { SVGProps } from 'react';

export default function UserLocationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 27 26" {...props}>
      <path d="M1.77911 10.6002C-0.0715406 11.4558 0.451585 13.9374 2.48388 13.9516L12.2331 13.9829C12.3924 13.9829 12.4324 14.037 12.4324 14.1821L12.4637 23.8743C12.4779 25.9836 14.9965 26.3614 15.9002 24.4232L25.7779 3.14199C26.7077 1.16884 25.1468 -0.243865 23.1797 0.671482L1.77911 10.6002ZM4.11098 11.8602C4.06235 11.8602 4.04815 11.8086 4.10519 11.7886L23.3624 2.97263C23.4397 2.92688 23.4942 2.96421 23.4342 3.05861L14.5869 22.2816C14.564 22.3416 14.5267 22.3358 14.5267 22.2759L14.5864 12.8128C14.5864 12.2185 14.1771 11.8005 13.5624 11.8005L4.11098 11.8602Z" />
    </svg>
  );
}
